import * as React from 'react';
import { IFieldBaseProperties, IFieldValueProperties, ISelectFieldItem, IFieldEvent } from './interfaces';
import SelectField from './SelectField';
import { DocumentType } from '../../model/common/DocumentType';

const documentTypeSelectFieldItems: ISelectFieldItem[] = DocumentType.map((d: string, index: number) : ISelectFieldItem => {
  return {
    label: d,
    value: index.toString()
  }
});

interface IDocumentTypeSelectProperties extends IFieldBaseProperties, IFieldValueProperties { 
    onChange?: (event: IFieldEvent) => void;
}

export default class DocumentTypeSelect extends React.PureComponent<IDocumentTypeSelectProperties> {
  render() {
    return <SelectField items={documentTypeSelectFieldItems} {...this.props} />
  }
}